import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import SingleState from '../states/single.state';

interface UpdateStatusData {
    [key: string]: any;
}

const initialState: SingleState = {
    data: {},
    loading: false,
    error: null,
};

const updateStatusSlice = createSlice({
    name: 'update-status',
    initialState,
    reducers: {
        setUpdateStatusData: (state, action: PayloadAction<UpdateStatusData>) => {
            return {
                ...state,
                data: action.payload
            };
        },
        resetUpdateStatusData: (state) => {
            return {
                ...state,
                data: {}
            };
        },
    },
});

export const { setUpdateStatusData, resetUpdateStatusData } = updateStatusSlice.actions;
export default updateStatusSlice.reducer;
